import instance, { PPR_API_URL } from 'api';
import { AxiosRequestConfig } from 'axios';
import {
  IApplication,
  IAssignExecutorAction,
  IPosition,
  ITask,
  ITechnicalRoom,
  IDefectType,
  IUser,
  IChangeTaskStatusAction,
} from './interfaces';

export const getTechnicalRoomPpr = (technicalRoomId: string) => {
  return instance(true, PPR_API_URL)
    .get<ITechnicalRoom>(`task/statusesByTechnicalRoom/${technicalRoomId}`)
    .then((response) => response.data);
};

export const getListByTechnicalRoomPpr = (config: AxiosRequestConfig) => {
  return instance(true, PPR_API_URL)
    .get<{ list: ITask[]; totalCount: number }>(`task/listByTechnicalRoom`, config)
    .then((response) => response.data);
};

export const changeTaskStatus = (taskId: number, data: IChangeTaskStatusAction) => {
  return instance(true, PPR_API_URL)
    .post('task/addAction/' + taskId, data)
    .then((response) => response.data);
};

export const assignTaskExecutor = (taskId: number, data: IAssignExecutorAction) => {
  return instance(true, PPR_API_URL)
    .post('task/addAction/' + taskId, data)
    .then((response) => response.data);
};

export const createPprApplication = (taskId: number, application: IApplication) => {
  return instance(true, PPR_API_URL)
    .post<IApplication>(`/task/${taskId}/createApplication`, application)
    .then((response) => response.data);
};

// dictionaries from service
export const getPositions = () => {
  return instance()
    .post<IPosition[]>('/dictionary/positions', {})
    .then((response) => response.data);
};

export const getUsers = (search: string | null, config: AxiosRequestConfig = {}) => {
  return instance()
    .post<IUser[]>('/users/list', search ? { search } : {}, config)
    .then((response) => response.data);
};

// dictionaries from ppr
export const getDefectTypes = () => {
  return instance(true, PPR_API_URL)
    .get<IDefectType[]>(`/task/defectTypes`)
    .then((response) => response.data);
};
